import { render } from "./MemberManagement.vue?vue&type=template&id=223e143e&scoped=true"
import script from "./MemberManagement.vue?vue&type=script&lang=js"
export * from "./MemberManagement.vue?vue&type=script&lang=js"

import "./MemberManagement.vue?vue&type=style&index=0&id=223e143e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223e143e"]])

export default __exports__